<div class="modal">
    <div class="header">
        <img src="../../../../../assets/icons/lock_icon.svg" alt="" class="lock-icon" />
        <span class="title">Conecta SUNAT y mejora tus condiciones</span>
    </div>

    <p class="description">Con tu información de compras y ventas en SUNAT, evaluamos tu negocio para ofrecerte:*</p>

    <div class="benefit">
        <img src="../../../../../assets/icons/tick-circle.svg" alt="" class="tick-icon" />
        <span>Una mejor línea de crédito</span>
    </div>
    <div class="benefit">
        <img src="../../../../../assets/icons/tick-circle.svg" alt="" class="tick-icon" />
        <span>Adelantos sobre tus facturas</span>
    </div>
    <div class="benefit">
        <img src="../../../../../assets/icons/tick-circle.svg" alt="" class="tick-icon" />
        <span>Evaluaciones más rápidas</span>
    </div>

    <span class="section-label">*Está sujeto a una evaluación de riesgos.</span>

    <div class="text-below">
        <span class="section-text">Puedes conectar con una cuenta secundaria de SUNAT en lugar de tu Clave SOL principal. 
            <a href="https://storage.googleapis.com/finsmart-websitefiles/legal/guia-generacion-usuario-secundario-sunat-2026-07-22.pdf" target="_blank" rel="noopener noreferrer" class="link-text">Ver el paso a paso</a>
        </span>

        <span class="section-label">La conexión se hace a través de un proveedor autorizado.</span>
    </div>

    <hr />

    <span class="section-label-continue">Antes de continuar</span>

    <div class="checkbox-row">
        <app-checkbox
            [checked]="representationTermsAccepted"
            (selectionChanged)="representationTermsAccepted = $event"
            [content]="representationTermsLabel"
        ></app-checkbox>
    </div>

    <div class="checkbox-row">
        <app-checkbox
            [checked]="solKeyTermsAccepted"
            (selectionChanged)="solKeyTermsAccepted = $event"
            [content]="solKeyTermsLabel"
        ></app-checkbox>
    </div>

    <div class="buttons">
        <fs-ui-button
            [action]="'button'"
            [label]="'Continuar'"
            [isDisabled]="!canContinue"
            (onClick)="continue()"
        ></fs-ui-button>

        <fs-ui-button
            class="cancelButton"
            [type]="'outline'"
            [label]="'Cerrar'"
            (onClick)="cancel()"
        ></fs-ui-button>
    </div>
</div>
